var layout = {
  mobileBreakpoint: 600
};
export default layout;